// extracted by mini-css-extract-plugin
export default {"root":"suggestions___root___c8a1197e","row2":"suggestions___row2___e6f7e69f"};